<div class="kUserSettings">
  <ul>
    <!--li class="kMenuItemLabel"><span class="kIcon kIconuser_small"></span>
            <div class="kMenuItem">
                <div>{{_userAuthentication.appUser?.fullName}}</div>
            </div>
        </li-->
    <li class="kMenuItemLabel">
      <span (dblclick)="egg()" class="kIcon kIconhouse"></span>
      <div class="kMenuItem">
        <div>{{ _userAuthentication.appUser?.partnerInfo?.name }}</div>
      </div>
    </li>
  </ul>

  <hr />
  <!--div class="kMenuItemLabel">
        <span>{{'app.languageMenu.selectLang' | translate}}</span>
    </div-->

  <ul class="kLanguages kOverrideFAIcons">
    <p-dropdown
      [options]="_languages"
      [(ngModel)]="_selectedLanguage"
      [scrollHeight]="300"
      (onChange)="onLangSelected($event)"
    ></p-dropdown>
  </ul>

  <ul class="kLanguages kOverrideFAIcons">
    <p-dropdown
      [options]="_dateFormats"
      [(ngModel)]="_selectedDateFormat"
      (onChange)="onDateFormatSelected($event)"
    ></p-dropdown>
  </ul>

  <hr />
  <div class="kLinks">
    <a (click)="changeAccountPopup.open(); parentPopup.close()">{{ 'app.userSettings.changeAccount' | translate }}</a>
    <a (click)="logout()">{{ 'app.userSettings.logout' | translate }}</a>
  </div>
</div>
<kPopupWidget #changeAccountPopup data-aid="changeAccountPopup" [popupWidth]="500" [popupHeight]="370" [modal]="true">
  <ng-template>
    <kChangeAccount></kChangeAccount>
  </ng-template>
</kPopupWidget>
